import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { DateUtil, I8N } from "@eres/core";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import { Redirect } from "react-router";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import { RDCCasesApi } from "../../rdcapi";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import RDCCaseListView from "./RDCCaseListView";
import RDCCaseGridView from "./RDCCaseGridView";
import { CasesResponse, RDCCase } from "../../rdcapi/entities";

export enum CaseStatusType {
	DRAFT = 1,
	PENDING = 2,
	ACTIVE = 3,
	REJECTED = 4,
	CLOSED = 5,
	PENDING_FOR_PAYMENT = 6,
	ON_HOLD = 7,
	PENDING_AUDITING = 8,
	CANCEL = 9,
	DELETED = 10,
}

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	rdcCases: RDCCase[];
	filterCases: RDCCase[];
	property?: AssetCard;
	year?: any;
}

export class RDCCases extends Component<Props, State> {

	constructor( props: Props ) {
		super( props );
		const property = props.location.state ? props.location.state.property : undefined;
		this.state = {
			isLoading: false,
			property: property,
			rdcCases: [],
			year: undefined,
			filterCases: [],
		};
	}

	componentDidMount() {
		this.loadRDCCases();
	}

	render() {
		const { property, isLoading } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <React.Fragment>
			<ListGridDataView
				isLoading={ isLoading }
				title={ `${ Strings.rdc_cases } - ${ lbl } : ${ val }` }
				pageTitle={ Strings.rdc_cases }
				dataAvailable={ this.state.filterCases && this.state.filterCases.length > 0 }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }>
			</ListGridDataView>
		</React.Fragment>;
	}

	private renderListView = () => {
		return <RDCCaseListView items={ this.state.filterCases }/>;
	};

	private renderGridView = () => {
		return <RDCCaseGridView items={ this.state.filterCases }/>;
	};

	private loadRDCCases() {
		if ( this.state.property && this.state.property.tabuPropertyId ) {
			showLoading();
			RDCCasesApi.getCasesOnProperty( this.state.property.tabuPropertyId ).then( ( resp: CasesResponse ) => {
				if ( resp.validationErrors && resp.validationErrors.length > 0 ) {
					showErrorMessage( RDCCasesApi.getValidationError( resp.validationErrors ) );
				} else {
					this.setState( {
						rdcCases: resp.recordSet ? resp.recordSet : [],
						filterCases: resp.recordSet ? resp.recordSet : [],
					} );
				}
				hideLoading();
			} ).catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		}

	}
}

export function getCaseNumber( item: RDCCase ) {
	return item.caseNo;
}

export function getCaseType( item: RDCCase ) {
	const val = I8N.isRTL() ? item.caseTypeNameAr : item.caseTypeNameEn;
	return val ? val : "";
}

export function getCaseStatus( item: RDCCase ) {
	const val = I8N.isRTL() ? item.caseStatusAr : item.caseStatusEn;
	return val ? val : "";
}

export function getRegistrationDate( item: RDCCase ) {
	const date = DateUtil.parseDate( item.caseActivateDate, "YYYY-MM-DDThh:mm:ss" );
	return DateUtil.formatDate( date, "DD/MM/YYYY", "en" );
}

export function getClosureDate( item: RDCCase ) {
	const date = DateUtil.parseDate( item.caseActivateDate, "YYYY-MM-DDThh:mm:ss" );
	return DateUtil.formatDate( date, "DD/MM/YYYY", "en" );
}

export function getCaseStatusColor( item: RDCCase ) {
	switch ( item.caseStatusId ) {
		case CaseStatusType.CANCEL:
			return "cancel"; // CANCELLED
			break;
		case CaseStatusType.PENDING_AUDITING:
			return "Pending-auditing"; // PENDING AUDITING
			break;
		case CaseStatusType.REJECTED:
			return "rejected"; // REJECTED
			break;
		case CaseStatusType.ACTIVE:
			return "active"; // ACTIVE
			break;
		case CaseStatusType.CLOSED:
			return "closed"; // CLOSED
			break;
		case CaseStatusType.PENDING_FOR_PAYMENT:
			return "pending-payment"; // PENDING PAYMENT
			break;
		case CaseStatusType.ON_HOLD:
			return "on-hold"; // ON HOLD
			break;
		case CaseStatusType.DELETED:
			return "deleted"; // DELETED
			break;
		case CaseStatusType.DRAFT:
			return "draft"; // DRAFT
			break;
		case CaseStatusType.PENDING:
			return "pending"; // PENDING
			break;
		default:
			return "#000000";
	}
}

